/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TrustCommercesubscriptionPlansSubscriptionPlan from './TrustCommercesubscriptionPlansSubscriptionPlan';

/**
 * The TrustCommerceSubscriptionPlansBody model module.
 * @module model/TrustCommerceSubscriptionPlansBody
 * @version v0.3
 */
export default class TrustCommerceSubscriptionPlansBody {
  /**
   * Constructs a new <code>TrustCommerceSubscriptionPlansBody</code>.
   * @alias module:model/TrustCommerceSubscriptionPlansBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TrustCommerceSubscriptionPlansBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrustCommerceSubscriptionPlansBody} obj Optional instance to populate.
   * @return {module:model/TrustCommerceSubscriptionPlansBody} The populated <code>TrustCommerceSubscriptionPlansBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TrustCommerceSubscriptionPlansBody();
      if (data.hasOwnProperty('subscription_plan'))
        obj.subscriptionPlan = TrustCommercesubscriptionPlansSubscriptionPlan.constructFromObject(data['subscription_plan']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TrustCommercesubscriptionPlansSubscriptionPlan} subscriptionPlan
 */
TrustCommerceSubscriptionPlansBody.prototype.subscriptionPlan = undefined;

